export const getConfiguracoes = ({ configuracoes }) => configuracoes;
